import moment from "moment";
import { exportTableToExcel } from "@/utils/reportExport";
import { formatDate } from "@/utils/utils";

export const MASTER_LIST_NO_TABLE = "MASTER_LIST_NO_TABLE";
export const MASTER_LIST_NO_ROWS = "MASTER_LIST_NO_ROWS";

function buildError(code, message) {
  const err = new Error(message);
  err.code = code;
  return err;
}

// b-table keeps placeholder rows in the tbody (the "no records" row, the busy
// slot). They are markup, not data, so they must not make an empty list look
// exportable.
function countDataRows(tableEl) {
  return Array.from(tableEl.querySelectorAll("tbody > tr")).filter(
    row =>
      !row.classList.contains("b-table-empty-row") &&
      !row.classList.contains("b-table-busy-slot"),
  ).length;
}

/**
 * Export a master-data b-table to Excel, exactly as it is rendered — the
 * current search filter and sort order are what the user sees, so they are what
 * lands in the file. Columns marked `report-export-skip` (row numbers, action
 * buttons) are dropped by the shared exporter.
 *
 * Throws an Error carrying `code` (MASTER_LIST_NO_TABLE / MASTER_LIST_NO_ROWS)
 * so callers can tell "nothing to export" apart from a real failure.
 *
 * @returns {string} the filename written
 */
export function exportMasterListToExcel({
  tableId,
  reportTitle,
  reportNameEn,
  branchName,
  clinicName,
}) {
  const tableEl = document.getElementById(tableId);
  if (!tableEl) {
    throw buildError(
      MASTER_LIST_NO_TABLE,
      `exportMasterListToExcel: table "${tableId}" not found`,
    );
  }
  if (!countDataRows(tableEl)) {
    throw buildError(
      MASTER_LIST_NO_ROWS,
      `exportMasterListToExcel: table "${tableId}" has no data rows`,
    );
  }

  const today = new Date();
  return exportTableToExcel({
    tableEl,
    // Master lists have no date range of their own. Passing dateFrom/dateTo
    // would print a "วันที่: from - to" row that reads as a data range, so the
    // export date goes in the title and the filename instead.
    reportTitle: `${reportTitle} (ข้อมูล ณ วันที่ ${formatDate(today)})`,
    reportNameEn: `${reportNameEn}_${moment(today).format("YYYY-MM-DD")}`,
    branchName,
    clinicName,
    sheetName: reportTitle,
  });
}
